// client/entityStore.ts
import { fromNetwork } from "../entities/adornisEntity";
import "../metaDataStore";
var EntityStore = class {
  static setCacheKey(entityClass, keyProperty) {
    this.keyMap[entityClass] = keyProperty;
  }
  static getCacheKey(entityClass) {
    return this.keyMap[entityClass] ?? "_id";
  }
  static getAndMerge(value, field) {
    const entity = this.store[value._class]?.[this.resolveKey(value._class, value, field)];
    if (entity)
      entity.mergeData(value, value[fromNetwork]);
    return entity;
  }
  static get(entityClass, key) {
    return this.store[entityClass]?.[key];
  }
  static put(entity, field) {
    const key = this.resolveKey(entity._class, entity, field);
    if (!key)
      return entity;
    if (!this.store[entity._class])
      this.store[entity._class] = {};
    return this.store[entity._class][key] = entity;
  }
  static drop(entity, field) {
    const key = this.resolveKey(entity._class, entity, field);
    if (!key || !this.store[entity._class])
      return;
    delete this.store[entity._class][key];
  }
  static resolveKey(entityClass, value, field) {
    const index = this.keyMap[entityClass] || "_id";
    const resolved = this.resolveStringKey(index, value);
    if (!resolved)
      try {
        return (field?.type()).resolveID(value);
      } catch {
      }
    return resolved;
  }
  static resolveStringKey(index, value) {
    if (typeof value !== "object")
      return;
    if (!Array.isArray(index))
      index = index.split(".");
    const [first, ...rest] = index;
    if (!first)
      return;
    if (!rest.length)
      return value[first];
    return this.resolveStringKey(rest, value[first]);
  }
};
EntityStore.store = {};
EntityStore.keyMap = {};
window.EntityStore = EntityStore;
export {
  EntityStore
};
